import { Controller } from 'react-hook-form'
import styled from 'styled-components'
import CpfCnpj from '@react-br-forms/cpf-cnpj-mask'

const GroupInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: ${(props) => props.width || '100%'};

  .label {
    font-size: 12px;
    color: #2d2d2d;
    font-weight: 600;
  }

  .input {
    border: none;
    font-size: 12px;
    color: #2d2d2d;
    padding-block: 6px;
    padding-inline: 6px;

    width: ${(props) => props.width || '100%'};
    border: 1px solid;
    border-color: ${(props) => (props.error ? '#ff0000' : '#CFCFCF')};
    outline: none;

    &:focus {
      border-color: #ffa200;
      outline: 1px solid #ffa200;

      /* se tiver erro */
      ${(props) => props.error && 'border-color: #ff0000; outline: 1px solid #ff0000;'}
    }
  }
`

const InputCpfCnpj = styled(CpfCnpj)`
  border: none;
  font-size: 12px;
  color: #2d2d2d;
  padding-block: 6px;
  padding-inline: 6px;

  width: ${(props) => props.width || '100%'};
  border: 1px solid;
  border-color: ${(props) => (props.error ? '#ff0000' : '#CFCFCF')};
  outline: none;

  &:focus {
    border-color: #ffa200;
    outline: 1px solid #ffa200;

    /* se tiver erro */
    ${(props) => props.error && 'border-color: #ff0000; outline: 1px solid #ff0000;'}
  }
`

export function CpfCnpjInput({ control, name, mask, maskChar, onChangeCustom, ...rest }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <GroupInput width={rest.width} error={rest.error}>
          <label htmlFor={rest.id ?? rest.label} className="label">
            {rest.label}
          </label>
          <InputCpfCnpj
            {...field}
            {...rest}
            id={rest.id ?? rest.label}
            mask={mask}
            maskChar={maskChar}
            className="input"
            onChange={(e) => {
              field.onChange(e)
              if (onChangeCustom) onChangeCustom(e)
            }}
          />
        </GroupInput>
      )}
    />
  )
}
